export { default as ChangePasswordButton } from "./ChangePasswordButton";



// WEBPACK FOOTER //
// ./src/components/common/ChangePassword/index.js